import { Routes, Route } from "react-router-dom";

// About us pages
import AboutDla from "./pages/AboutDla";
import MeetsTheBoard from "./pages/MeetsTheBoard";
import WorkWeDo from "./pages/WorkWeDo";
import Education from "./pages/Education";
import Regulation from "./pages/Regulation";
import MembershipSupport from "./pages/MembershipSupport";
import OurPolicies from "./pages/OurPolicies";
import BecomeAMember from "./pages/BecomeAMember";
import DLAFellowship from "./pages/DLAFellowship";
import DLAFellowshipAwards from "./pages/DLAFellowshipAwards";
import DLASpecialRecognitionAward from "./pages/DLASpecialRecognitionAward";
import BoardMemberDetail from "./pages/BoardMemberDetail";
import PolicyDetail from "./pages/PolicyDetail";
import ItemDetail from "./pages/ItemDetail";
import FindOutMoreView from "./pages/FindOutMorePage";
import ReasontoJion from "./pages/ReasontoJion";
import NewsPostDetail from "./pages/NewsPostDetail";


const AboutRoutes = () => {
  return (
    <Routes>
      {/* These paths are relative to /about */}
      <Route path="/about" element={<AboutDla />} />
      <Route path="/about/meet-the-board" element={<MeetsTheBoard />} />
      <Route path="/board-member/:id" element={<BoardMemberDetail />} />
      <Route path="/about/work-we-do" element={<WorkWeDo />} />
      <Route path="/about/work-we-do/education" element={<Education />} />
      <Route path="/about/work-we-do/regulation" element={<Regulation />} />
      <Route path="/about/work-we-do/membership-support" element={<MembershipSupport />} />
      <Route path="/about/our-policies" element={<OurPolicies />} />
      <Route path="/about/become-member" element={<BecomeAMember />} />
      <Route path="/about/dla-fellowship" element={<DLAFellowship />} />
      <Route path="/about/dla-fellowship/awards" element={<DLAFellowshipAwards />} />
      <Route path="/about/dla-fellowship/special-recognition" element={<DLASpecialRecognitionAward />} />
      <Route path="/policies/:policySlug/items/:itemSlug" element={<ItemDetail />} />
      <Route path="/our-policies/reasons-to-join-dla" element={<ReasontoJion />} />
      <Route path="/policies/:policySlug" element={<PolicyDetail />} />
      <Route path="/about/work-we-do/:slug" element={<FindOutMoreView />} />
      <Route path="/news/:slug" element={<NewsPostDetail />} />
    </Routes>
  );
};

export default AboutRoutes;